// extracted by mini-css-extract-plugin
module.exports = {"container":"NP","links":"OP"};